import Listagem from '../componentes/Filiado/listagem';

function Filiado() {
  return (
    <Listagem></Listagem>
  );
}

export default Filiado;
